// https://github.daumkakao.com/webtech/agent
import { App, Browser, getAgent, OS } from '@kakao/agent';

export const compareVersion = (a, b) => {
    const aDigit = String(a).split('.').map((v) => Number(v));
    const bDigit = String(b).split('.').map((v) => Number(v));

    if ([...aDigit, ...bDigit].some((v) => isNaN(v))) {
        return NaN;
    }

    const digitLength = Math.max(aDigit.length, bDigit.length);
    while (aDigit.length < digitLength) aDigit.push(0);
    while (bDigit.length < digitLength) bDigit.push(0);

    for (let index = 0; index < digitLength; index++) {
        if (aDigit[index] !== bDigit[index]) {
            return Number(aDigit[index]) - Number(bDigit[index]);
        }
    }

    return 0;
};


// match: 5.5, 5.10.2
const VERSION_REGEX = /\d+(\.\d+)+(\.\d+)*/g;
// match: NAVER*(+6.6.1*)
const NAVER_VERSION_USERAGENT_REGEX = /NAVER\w*\([\w\s].+(\d+(\.\d+)+(\.\d+)*).*\)/gi;

const getNaverVersion = (agent) => {
    const matchedAgentList = agent.match(NAVER_VERSION_USERAGENT_REGEX);

    if (!matchedAgentList || matchedAgentList.length < 0) {
        return undefined;
    }

    const matchedVersionList = matchedAgentList[0].match(VERSION_REGEX);
    return matchedVersionList[0];
};


/* 용어 정리 */
// more: 이상
// less: 이하
// greater: 초과
// under: 미만
export default function BrunchUserAgent () {
    const userAgent = navigator.userAgent.toLowerCase();
    const { app, browser, browserVersion, os, osVersion, isDesktop, isIE, isTablet, isAndroid, ...agent } = getAgent();

    const compareBrowserVersion = (target) => compareVersion(browserVersion, target);
    const compareOSVersion = (target) => compareVersion(osVersion, target);

    const isBlackberry = /(blackberry)/g.test(userAgent);
    const isMobile = agent.isMobile || isBlackberry;
    const isMobileTablet = isMobile || isTablet;

    const isIOS = os === OS.iOS;
    const isIOSMobile = isIOS && isMobile;
    const isIPod = /(ipod)/g.test(userAgent);
    const isIPhone = !isIPod && /(iphone)/g.test(userAgent);

    const isFacebook = app === App.Facebook;
    const isTwitter = app === App.Twitter;

    const isChrome = browser === Browser.Chrome && app === App.Unknown;
    const isSafari = browser === Browser.Safari && app === App.Unknown;
    const isFirefox = browser === Browser.FireFox;
    const isOpera = browser === Browser.Opera;

    const naverVersion = getNaverVersion(userAgent);
    const isNaver = !!naverVersion;

    return {
        isPC: isDesktop,
        isIE,
        isIE9Less: isIE && compareBrowserVersion(9) <= 0,
        isIE9Under: isIE && compareBrowserVersion(9) < 0,
        isIE11Under: isIE && compareBrowserVersion(11) < 0,
        isChrome,
        isSafari,
        isFirefox,
        isOpera,
        isMobile,
        isMobileTablet,
        isIOS,
        isIOS10More: isIOS && compareOSVersion(10) > 0,
        isIOS13: isIOS && compareOSVersion(13) >= 0 && compareOSVersion(14) < 0,
        isIOSMobile,
        isIOSMobileSafari: isIOSMobile && isSafari,
        isIOS9MoreSafari: isIOS && compareOSVersion(9) >= 0 && isSafari,
        isIOS9MoreFacebook: isIOS && compareOSVersion(9) >= 0 && isFacebook,
        isIOS13MoreSafari: isIOS && compareOSVersion(13) >= 0 && isSafari,
        isIPad: isIOS && isTablet,
        isIPod,
        isIPhone,
        isIPhoneTwitter: isTwitter && isIPhone,
        isAndroid,
        isAndroid41More: isAndroid && compareOSVersion('4.1') >= 0,
        isFacebook,
        isTwitter,
        isNaver,
        isNaver661More: isNaver && compareVersion(naverVersion, '6.6.1') >= 0,
        isBlackberry,
        isApplewebkit: /(applewebkit)/g.test(userAgent),
    };
}
